fx.ns("common.popups", class CheckPrints extends shared.popups.BasePersonPopup{
    
    constructor(text)
    {
        super(null, fx.get("assets").personSure);
        this.contentWidth = 400;
        this.contentHeight = 170;
        this.text = text;
    }

    onReady()
    {
        super.onReady();
        this.on("click", this._onOk ,this.okButton);
    }

    create()
    {
        super.create();
 
        this.addChild(new fx.components.Text({text: this.text, className:"center bold"}), {height:50, left:0, top:10, width:"100%"});

        this.okButton = new fx.components.Button({label : fx.text("J'ai compris"), type : "filled"});
        
        this.addChild(this.okButton, {width : 200, top: 20, left: "center"});
    }

    _onOk(){
        this.close();
    }

});